<template>
  <!-- Loing Dialog -->
  <transition name="fade">
    <div class="phrase-overlay" v-if="edit_drawer">
      <div class="create-phrase-wrap" style="width:420px">
        <div class="list-create">
          <div class="newmessage-title">
            {{ checkList.length }}件のインフルエンサーを一括編集
            <div class="flex-space"></div>
            <div class="newmessage-button" @click="closeEditDrawer()">
              <font-awesome-icon :icon="['fal', 'times']" />
            </div>
          </div>
          <div class="list-create-box">
            <div class="list-create-name">編集する項目</div>
            <el-select size="small" v-model="select_item">
              <el-option label="ステータス" value="status"></el-option>
              <el-option label="コメント" value="comment"></el-option>
              <el-option label="カスタマイズタグ" value="tag"></el-option>
            </el-select>
          </div>
          <div class="list-create-box" v-if="select_item == 'status'">
            <div class="list-create-name">ステータス</div>
            <status :status="status" :reffrer="'editBulk'" @addStatus="addStatus" />
          </div>
          <div class="list-create-box" v-if="select_item == 'comment'">
            <template v-if="normalCommentColumns.length > 0">
              <div class="list-create-name">コメント列</div>
              <el-select size="small" v-model="comment_column_id" style="width: 100%; margin-bottom: 10px">
                <el-option
                  v-for="column in normalCommentColumns"
                  :key="column.column_id"
                  :label="commentColumnLabel(column)"
                  :value="column.column_id"
                ></el-option>
              </el-select>
              <div class="list-create-name">
                コメント（{{ listCommentMaxContentLength }}文字以内）
                <span v-if="selectedCommentColumn && selectedCommentColumn.is_numeric_only == 1">・数値のみ</span>
              </div>
              <el-input size="small" v-model="comment" :maxlength="listCommentMaxContentLength" show-word-limit></el-input>
            </template>
            <div v-else class="list-create-name" style="color: #999">
              コメント列の読み込みに失敗しました。画面を再読み込みしてください
            </div>
          </div>
          <div class="list-create-box" v-if="select_item == 'tag'">
            <div class="list-create-name">カスタマイズタグ</div>
            <div class="flex-row" style="gap:10px">
              <sidemenuCustomizeTag :sns_type="'edit_bulk'" :edit_tag.sync="edit_tag" style="width:70%" />
              を
              <el-select style="width:80px" size="mini" v-model="update_type" placeholder="追加/削除">
                <el-option :label="'追加'" :value="'add'">追加</el-option>
                <el-option :label="'削除'" :value="'delete'">削除</el-option>
              </el-select>
            </div>
          </div>

          <div class="list-create-footer">
            <el-button size="small" :disabled="edit_loading" @click="edit_loading ? '' : closeEditDrawer()">キャンセル</el-button>
            <el-button size="small" type="primary" native-type="submit" :disabled="edit_loading || disabled" @click="editInfluencer()">
              <div class="flex-row">
                変更
                <div class="loader--mini" v-show="edit_loading"></div>
              </div>
            </el-button>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
const root = process.env.VUE_APP_API;
const editInfluencerAPI = root + "/api/list/edit_influencer";
import status from "./status";
import sidemenuCustomizeTag from "../sidemenu/sidemenu_customize_tag";
import {
  isValidListCommentContentLength,
  LIST_COMMENT_MAX_CONTENT_LENGTH,
  LIST_COMMENT_MAX_CONTENT_LENGTH_MESSAGE,
} from "@/utils/listCommentConst";

export default {
  name: "editInfluencer",
  props: ["edit_drawer", "checkList", "list_id", "sns_type", "comment_columns"],
  components: {
    status,
    sidemenuCustomizeTag,
  },
  data() {
    return {
      edit_loading: false,
      select_item: "",
      status: "",
      comment: "",
      comment_column_id: "",
      listCommentMaxContentLength: LIST_COMMENT_MAX_CONTENT_LENGTH,
      edit_tag: { tags: {} },
      update_type: "add",
    };
  },
  computed: {
    token() {
      return this.$store.state.token;
    },
    activate() {
      return this.$store.state.activate;
    },
    normalCommentColumns() {
      return (this.comment_columns || []).filter((column) => column.column_type === "normal");
    },
    selectedCommentColumn() {
      return this.normalCommentColumns.find((column) => String(column.column_id) === String(this.comment_column_id));
    },
    disabled() {
      if (this.select_item == "") {
        return true;
      } else if (this.select_item == "tag" && Object.keys(this.edit_tag.tags).length == 0) {
        return true;
      } else if (this.select_item == "comment") {
        return this.normalCommentColumns.length === 0 || !this.comment_column_id;
      } else {
        return false;
      }
    },
  },
  mounted() {},
  methods: {
    closeEditDrawer() {
      this.select_item = "";
      this.comment_column_id = "";
      this.$emit("closeEditDrawer");
    },
    commentColumnLabel(column) {
      if (column.title) {
        return column.title;
      }
      const index = this.normalCommentColumns.findIndex((item) => item.column_id === column.column_id);
      return "コメント" + (index + 1);
    },
    addStatus(name) {
      this.status = name;
    },
    editInfluencer() {
      if (this.select_item == "comment" && !isValidListCommentContentLength(this.comment)) {
        this.$message({
          type: "error",
          offset: 7,
          showClose: true,
          message: LIST_COMMENT_MAX_CONTENT_LENGTH_MESSAGE,
        });
        return;
      }
      if (
        this.select_item == "comment"
        && this.selectedCommentColumn
        && this.selectedCommentColumn.is_numeric_only == 1
        && this.comment !== ""
        && !/^\d{1,9}(\.\d{1,2})?$/.test(this.comment)
      ) {
        this.$message({
          type: "error",
          offset: 7,
          showClose: true,
          message: "整数部9桁・小数第2位までの数値を入力してください",
        });
        return;
      }
      this.edit_loading = true;
      var params = new URLSearchParams();
      if (this.select_item == "comment") var update_value = this.comment;
      if (this.select_item == "status") update_value = this.status;
      if (this.select_item == "tag") update_value = JSON.stringify(this.edit_tag.tags);
      params.append("token", this.token);
      params.append("list_id", this.list_id);
      params.append("sns_type", this.sns_type);
      params.append("select_item", this.select_item);
      params.append("influencer", JSON.stringify(this.checkList));
      params.append("update_type", this.update_type);
      params.append("update_value", update_value);
      if (this.select_item == "comment") {
        params.append("column_id", this.comment_column_id);
      }
      this.axios
        .post(editInfluencerAPI, params)
        .then((response) => {
          if (response.data.status == "OK") {
            this.edit_loading = false;
            this.$message({
              type: "success",
              offset: 7,
              showClose: true,
              message: this.checkList.length + "名のインフルエンサーを一括編集しました",
            });
            this.$emit(
              "editBulkUpdate",
              this.select_item,
              update_value,
              this.update_type,
              this.select_item == "comment" ? this.comment_column_id : null
            );
            this.select_item = "";
            this.comment = "";
            this.comment_column_id = "";
            this.status = "";
            this.edit_tag = { tags: {} };
            this.update_type = "add";
            this.closeEditDrawer();
          } else {
            this.edit_loading = false;
            this.$message({
              type: "error",
              offset: 7,
              showClose: true,
              message: response.data.message || "一括編集に失敗しました",
            });
          }
        })
        .catch(() => {
          this.edit_loading = false;
        });
    },
  },
  watch: {
    select_item(value) {
      if (value === "comment" && this.normalCommentColumns.length === 1) {
        this.comment_column_id = this.normalCommentColumns[0].column_id;
      }
    },
  },
};
</script>
